(function () {
	angular
		.module('trackeye')
		.factory('Account', _AccountFactory);

	_AccountFactory.$inject = ["ConfigurationService", "LanguageService", "C4ApiService"];

	function _AccountFactory(ConfigurationService, LanguageService, api) {

		/**
		 * @constructor
		 */
		function Account() {
			this.id = undefined;
			this.name = undefined;
			this.email = undefined;
			this.description = undefined;
			this.username = undefined;
			this.currency = undefined;
			this.balance = undefined;
			this.insecure = undefined;

			/**
			 * @type {Configuration}
			 */
			this.configuration = ConfigurationService.factory('te-account', 'Account information and settings');
		}

		Account.prototype.getConfiguration = function () {
			return this.configuration;
		};

		/**
		 *
		 * @param {string} password
		 * @returns {Promise}
		 */
		Account.prototype.save = function (password) {
			/**
			 * We're accepting the password as a parameter,
			 * instead of saving it to the object. To prevent it from being exposed
			 */
			return api.saveAccount({
				name: this.name,
				username: this.username,
				password: password,
				description: this.description
			});
		};

		/**
		 * Asserts if the account is initialized, by checking
		 * if the account id, is defined.
		 * @returns {boolean}
		 */
		Account.prototype.isInitialized = function () {
			return !!this.id;
		};

		Account.prototype.populate = function (data) {
			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					this[key] = data[key];
				}
			}

			/**
			 * Find the account configuration (data object),
			 * if it does not exists, create the default object.
			 */
			ConfigurationService.findOneByName('te-account').then((function (config) {
				this.configuration.copy(config);
				LanguageService.setLanguage(this.configuration.get('settings.locale'));
				moment.tz.setDefault(this.configuration.get('settings.timezone'));

			}).bind(this), (this._makeConfiguration).bind(this));

			return this;
		};

		Account.prototype.isInsecure = function() {
			return this.insecure;
		};

		Account.prototype.getId = function() {
			return this.id;
		};

		Account.prototype.getName = function() {
			return this.name;
		};

		Account.prototype.getEmail = function() {
			return this.email;
		};

		Account.prototype.getUsername = function() {
			return this.username;
		};

		Account.prototype.getCurrency = function() {
			return this.currency;
		};

		Account.prototype.getBalance = function() {
			return this.balance;
		};

		Account.prototype.getStreet = function() {
			return this.configuration.get('personal.street');
		};

		Account.prototype.getZip = function() {
			return this.configuration.get('personal.zip');
		};

		Account.prototype.getTown = function() {
			return this.configuration.get('personal.town');
		};

		Account.prototype.getPhone = function() {
			return this.configuration.get('personal.phone');
		};

		Account.prototype.getPhone2 = function() {
			return this.configuration.get('personal.phone2');
		};

		Account.prototype.getLocale = function() {
			return this.configuration.get('settings.locale');
		};

		Account.prototype.getTimezone = function () {
			return this.configuration.get('settings.timezone');
		};

		Account.prototype.getDateFormat = function () {
			var format = this.configuration.get('settings.format.date');
			return format || "DD/MM/YYYY";
		};

		Account.prototype.getTimeFormat = function () {
			var format = this.configuration.get('settings.format.time');
			return format || "HH:mm";
		};

		Account.prototype.getDatetimeFormat = function () {
			return this.getDateFormat()+" "+this.getTimeFormat();
		};

		Account.prototype._makeConfiguration = function (resp) {
			if (resp.status !== 404)
				console.error(resp);

			this.configuration.setData({
				personal: {
					street: "",
					zip: "",
					town: "",
					phone: "",
					phone2: ""
				},
				settings: {
					locale: LanguageService.getDefaultLanguage(),
					timezone: "",
					format: {
						date: "",
						time: ""
					}
				}
			});

			this.configuration.save();
		};

		return Account;
	}
})();